export default {
  shopPerfumes: {
    en: 'Shop perfumes',
  },
  shopColognes: {
    en: 'Shop colognes',
  },
  about: {
    en: 'About Scentbird',
  },
  help: {
    en: 'Help',
  },
}
